var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[_c('el-pagination',{attrs:{"current-page":_vm.mpage,"page-sizes":_vm.psize,"page-size":10,"layout":_vm.playout,"total":_vm.ctotal},on:{"current-change":_vm.pageChange,"size-change":_vm.sizeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }